import type { enStokLots } from '../en/stok-lots';

export const idStokLots: Record<keyof typeof enStokLots, string> = {
  // ---- Status ---------------------------------------------------------------------------
  'stok.lotStatus.available': 'Tersedia',
  'stok.lotStatus.on_hold': 'Ditahan',
  'stok.lotStatus.quarantined': 'Karantina',
  'stok.lotStatus.recalled': 'Ditarik',

  // ---- Expiry ---------------------------------------------------------------------------
  'stok.lots.expiry.none': 'Tanpa kedaluwarsa',
  'stok.lots.expiry.today': 'Kedaluwarsa hari ini',
  'stok.lots.expiry.pastOne': 'Kedaluwarsa 1 hari lalu',
  'stok.lots.expiry.past': 'Kedaluwarsa {days} hari lalu',
  'stok.lots.expiry.leftOne': '1 hari lagi',
  'stok.lots.expiry.left': '{days} hari lagi',

  // ---- List -----------------------------------------------------------------------------
  'stok.lots.title': 'Lot & kedaluwarsa',
  'stok.lots.subtitle':
    'Stok per lot di {branch}, lengkap dengan tanggal kedaluwarsa, penahanan, dan nilai.',
  'stok.lots.alertsTitle': 'Peringatan kedaluwarsa',
  'stok.lots.alertsDesc':
    'Lot bersisa stok yang sudah kedaluwarsa atau akan kedaluwarsa dalam rentang yang dipilih. Hari dihitung dari tanggal usaha {date}.',
  'stok.lots.alertsDescShort':
    'Lot bersisa stok yang sudah kedaluwarsa atau akan kedaluwarsa dalam rentang yang dipilih.',
  'stok.lots.horizon': 'Rentang peringatan',
  'stok.lots.horizonDays': '{days} hari',
  'stok.lots.expiredCount': 'Lot kedaluwarsa',
  'stok.lots.expiredCountDesc': 'Masih ada di stok setelah tanggal kedaluwarsa.',
  'stok.lots.expiringCount': 'Kedaluwarsa dalam {days} hari',
  'stok.lots.expiringCountDesc': 'Pakai lebih dulu (yang kedaluwarsa duluan, keluar duluan).',
  'stok.lots.exposure': 'Nilai pada biaya rata-rata:',
  'stok.lots.expiredList': 'Sudah kedaluwarsa',
  'stok.lots.expiringList': 'Kedaluwarsa dalam {days} hari',
  'stok.lots.alertsNoneExpired': 'Tidak ada lot kedaluwarsa di stok.',
  'stok.lots.alertsNoneExpiring': 'Tidak ada lot yang kedaluwarsa dalam {days} hari.',
  'stok.lots.alertsMore': '+{count} lainnya — lihat daftar di bawah.',
  'stok.lots.allStatuses': 'Semua status',
  'stok.lots.searchPlaceholder': 'Kode lot, barang, SKU, atau sumber',
  'stok.lots.includeEmpty': 'Sertakan lot yang sudah habis',
  'stok.lots.listTitle': 'Daftar lot',
  'stok.lots.listDesc': 'Jumlah per lot dan lokasi. Nilai = jumlah × biaya rata-rata cabang.',
  'stok.lots.empty':
    'Belum ada lot di stok — lot dibuat saat barang berlot diterima atau diberi saldo awal.',
  'stok.lots.emptyFiltered': 'Tidak ada lot yang cocok dengan filter ini.',
  'stok.lots.col.code': 'Kode lot',
  'stok.lots.col.expiry': 'Kedaluwarsa',
  'stok.lots.open': 'Buka lot {code}',
  'stok.lots.source.goodsReceipt': 'Penerimaan barang',
  'stok.lots.source.waste': 'Catatan waste',

  // ---- Detail ---------------------------------------------------------------------------
  'stok.lots.back': 'Semua lot',
  'stok.lots.detailLoading': 'Lot',
  'stok.lots.detailTitle': 'Lot {code}',
  'stok.lots.detailSubtitle': '{item} · {sku}',
  'stok.lots.factsTitle': 'Rincian lot',
  'stok.lots.factsDesc': 'Sisa hari kedaluwarsa dihitung dari tanggal usaha {date}.',
  'stok.lots.fact.expiry': 'Tanggal kedaluwarsa',
  'stok.lots.fact.manufactured': 'Tanggal produksi',
  'stok.lots.fact.receivedAt': 'Diterima pada',
  'stok.lots.fact.supplier': 'Pemasok',
  'stok.lots.fact.qty': 'Jumlah di stok',
  'stok.lots.fact.valueHint': 'Jumlah × biaya rata-rata cabang',
  'stok.lots.balancesTitle': 'Stok per lokasi',
  'stok.lots.balancesDesc': 'Lokasi tempat jumlah lot ini berada sekarang.',
  'stok.lots.balancesEmpty': 'Stok lot ini sudah habis.',
  'stok.lots.actionsTitle': 'Tahan dan lepas',
  'stok.lots.actionsDesc':
    'Lot yang ditahan tetap ada di stok, tetapi tidak ditawarkan untuk dipakai sampai dilepas.',
  'stok.lots.readOnly': 'Peran Anda dapat melihat lot, tetapi tidak dapat menahan atau melepasnya.',
  'stok.lots.releaseNeedsApprove':
    'Lot ini sedang ditahan. Melepasnya butuh izin persetujuan — minta bantuan manajer.',
  'stok.lots.holdNeedsReceive': 'Menahan lot butuh izin penerimaan barang.',
  'stok.lots.recalledNote': 'Lot ini ditarik dan tidak dapat dilepas di sini.',
  'stok.lots.hold': 'Tahan lot',
  'stok.lots.holding': 'Menahan…',
  'stok.lots.holdTitle': 'Tahan lot {code}?',
  'stok.lots.holdBody':
    'Lot tetap ada di stok, tetapi diblokir untuk dipakai (dilewati FEFO) sampai dilepas.',
  'stok.lots.holdReason': 'Alasan',
  'stok.lots.holdHint': 'Contoh: “Kemasan rusak, menunggu pemasok”.',
  'stok.lots.held': 'Lot {code} ditahan.',
  'stok.lots.release': 'Lepas lot',
  'stok.lots.releasing': 'Melepas…',
  'stok.lots.releaseTitle': 'Lepas lot {code}?',
  'stok.lots.releaseBody': 'Lot dapat dipakai lagi.',
  'stok.lots.releaseReason': 'Alasan pelepasan',
  'stok.lots.released': 'Lot {code} dilepas.',
  'stok.lots.holdsTitle': 'Riwayat penahanan',
  'stok.lots.holdsDesc': 'Semua penahanan lot ini, dari yang terlama.',
  'stok.lots.holdsEmpty': 'Lot ini belum pernah ditahan.',
  'stok.lots.col.heldAt': 'Ditahan',
  'stok.lots.col.holdReason': 'Alasan',
  'stok.lots.col.releasedAt': 'Dilepas',
  'stok.lots.col.releaseReason': 'Alasan pelepasan',
  'stok.lots.holdOpen': 'Masih ditahan',
  'stok.lots.holdSource.manual': 'Manual',
  'stok.lots.holdSource.goodsReceipt': 'Saat penerimaan',
  'stok.lots.traceTitle': 'Jejak mutasi',
  'stok.lots.traceDesc':
    'Semua mutasi buku stok untuk lot ini, dari yang terlama (+ masuk, − keluar).',
  'stok.lots.traceEmpty': 'Belum ada mutasi untuk lot ini.',
  'stok.lots.col.qtyAfter': 'Sisa di lokasi',
};
